import catalogVersion from './catalogVersion.json';
import { normalizeLocale } from './i18n';
const { version } = catalogVersion;

const requests = new Map();
export function clearPageDataCache() { requests.clear(); }

async function readData(file, signal) {
  const url = `/data/${version}/${file}`;
  if (!requests.has(url)) {
    requests.set(url, fetch(url, { cache: 'force-cache' }).then(response => {
      if (response.ok === false) {
        const error = new Error(`Page data unavailable (${response.status})`);
        error.status = response.status;
        throw error;
      }
      return response.json();
    }).catch(error => { requests.delete(url); throw error; }));
  }
  const data = await requests.get(url);
  if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
  return data;
}

export function loadCatalog(locale, category, signal) {
  const file = category ? `categories/${encodeURIComponent(category)}.json` : 'catalog.json';
  return readData(`${normalizeLocale(locale)}/${file}`, signal).catch(error => {
    if (category && error.status === 404) return { categories: [], images: [] };
    throw error;
  });
}

export function loadImageData(locale, slug, signal) {
  const id = slug?.match(/-(\d+)$/)?.[1];
  // Legacy SPA /view routes have no ID. Production redirects these server-side.
  return id ? readData(`${normalizeLocale(locale)}/images/${id}.json`, signal) : loadCatalog(locale, null, signal);
}
